export var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-portal/es/utils.js
// module id = eL8z
// module chunks = 0